<script>
export default {
  data() {
    return {
      seafloorPhotomosaic_url: `${process.env.APIBASE}/media/gallery/map`,
    };
  },
};
</script>

<template>
  <div style="height: 100%; width: 100%;">
    <b-row class="app-section">
      <b-col cols="12" class="seafloor-photomosaic-section">
        <b-container>
          <b-row class="title">
            <b-col cols="12">
              <h4>Seafloor Photomosaic Demonstration</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p>
                This is a demonstration version of the interactive map, which
                incorporates seafloor photomosaics. Users can zoom into a
                photomosaic that shows high-resolution digital still images of
                the seafloor in the location, taken by cameras mounted on
                remotely operated vehicles (ROVs) and automated underwater
                vehicles (AUVs). An interactive tool also allows different
                bathymetry layers, media, and photomosaics on the map to be
                turned on and off. These functions will eventually be included
                on the main interactive map of the Interactive Oceans Data
                Portal to improve the overall user experience.
              </p>
            </b-col>
          </b-row>
          <b-row
            class="seafloor-photomosaic-iframe"
            align-v="center"
            style="height: 100%; width: 100%"
          >
            <b-col cols="12" style="height: 100%;">
              <b-embed
                type="iframe"
                aspect="4by3"
                :src="`${seafloorPhotomosaic_url}`"
                allowfullscreen
              ></b-embed>
              <br />
            </b-col>
          </b-row>
          <br />
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>
<style>
.title {
  margin-top: 20px;
  font-size: 20px;
}
.seafloor-photomosaic-iframe {
  border: 0.5px solid black;
}
</style>
